import * as Yup from "yup";

/**
 * @description E5 form rules, shared by Zone and Network forms (from the E5 design)
 * Name max 100, Number max 10, letters, numbers, spaces and - _ . & only.
 * Same charset as the backend DataAnnotations on ZoneVM / CreateNetworkVM.
 */
export const ALLOWED_CHARS = /^[A-Za-z0-9 \-_.&]*$/;
export const CHARS_MSG = "Only letters, numbers, spaces, -, _, . and & are allowed.";
export const NAME_MAX = 100;
export const NUMBER_MAX = 10;
export const PATH_MAX = 100;

/**
 * @param {*field label used in messages e.g. "Zone Name"} label
 * @param {*max length} max
 */
const textRule = (label, max) =>
  Yup.string()
    .test("required", `${label} is required.`, (v) => !!(v && v.trim()))
    .max(max, `${label} cannot exceed ${max} characters.`)
    .matches(ALLOWED_CHARS, CHARS_MSG);

export const URL_MSG = "Enter a valid URL starting with http:// or https://.";
export const URL_MAX = 100;

export const networkSchema = Yup.object().shape({
  networkName: textRule("Network Name", NAME_MAX),
  networkNumber: textRule("Network Number", NUMBER_MAX),
  mediaFieBasePath: Yup.string()
    .test("required", "Media URL is required.", (v) => !!(v && v.trim()))
    .test("url", URL_MSG, (v) => !v || !v.trim() || /^https?:\/\/\S+$/i.test(v.trim()))
    .max(URL_MAX, `Media URL cannot exceed ${URL_MAX} characters.`),
});

export const zoneSchema = Yup.object().shape({
  zoneName: textRule("Zone Name", NAME_MAX),
  zoneNumber: textRule("Zone Number", NUMBER_MAX),
  timeZoneDetails: Yup.string().required("Time Zone is required."),
  // paths are optional in the E5 design; length guard only
  scheduleFileBasePath: Yup.string().max(
    PATH_MAX,
    `SCH Path cannot exceed ${PATH_MAX} characters.`
  ),
  verificationFileBasePath: Yup.string().max(
    PATH_MAX,
    `VER Path cannot exceed ${PATH_MAX} characters.`
  ),
});
